const InspireID = ({ id }: { id: string }) => (
  <div>
    <span>INSPIRE ID: {id}</span>
  </div>
);

export default InspireID;
